import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { LogoLoading } from '@/shared/ui/custom/logo-loading';

interface BaseLayoutProps {
  children: React.ReactNode;
  fullHeight?: boolean; // For pages like interactive viewer that need fixed viewport height
  isLoading?: boolean; // Show logo loading animation
  loadingMessage?: string; // Optional message to display while loading
  loadingVariant?: 'fade' | 'pulse' | 'breathing'; // Animation variant
  loadingSize?: 'sm' | 'md' | 'lg' | 'xl'; // Logo size
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ 
  children, 
  fullHeight = false,
  isLoading = false,
  loadingMessage,
  loadingVariant = 'breathing',
  loadingSize = 'xl'
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content wrapper */}
      <div className="lg:pl-64">
        {/* Topbar */}
        <Topbar onMenuClick={toggleSidebar} />
        
        {/* Main content */}
        <main className={fullHeight ? "h-[calc(100vh-4rem)] bg-background overflow-hidden" : "min-h-screen bg-background"}>
          {isLoading ? (
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
              <LogoLoading 
                variant={loadingVariant}
                size={loadingSize}
                message={loadingMessage}
              />
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
};

export default BaseLayout; 